import { getContext } from '@fiverr-private/fiverr_context';
import { getShortLanguageCode } from '@fiverr-private/localization';
import { formatDate } from '@fiverr-private/futile';

const DEFAULT_MONTH_FORMAT = 'long';

export const useFormatDate = (date: Date): string => {
    const { locale } = getContext();
    const localeShort = getShortLanguageCode(locale);

    return formatDate(date, {
        month: DEFAULT_MONTH_FORMAT,
        locale: localeShort,
    });
};
